import {useState} from 'react';
import {useParams} from 'react-router-dom';

import {Stack} from '@mantine/core';

import {
    FormPageLayout,
    PlatformLoader,
} from '@flexinet/ui-components';

import {Profile} from '../profile/Profile';
import {FormDrawer} from '../drawers/FormDrawer';

import {EditPageNavigation} from '../navigation/EditPageNavigation';

import {useEditPageTools} from '../hooks/useEditPageTools';
import {useProduct} from '../hooks/useProduct.ts';
import {Product} from '../types';

export const EditPage = () => {

    const {id: productId} = useParams();

    if (typeof productId === 'undefined') {
        throw new Error('productId is required parameter');
    }

    const {record: product, loading, updateRecord, fetchRecord} = useProduct(productId);

    const [drawerOpened, setDrawerOpened] = useState(false);

    const {tools} = useEditPageTools({onEdit: () => setDrawerOpened(true)});

    if (loading || !product) {
        return <PlatformLoader message='Loading product...Please wait'/>;
    }

    const handleDrawerSubmit = (values: Product) => {
        updateRecord(values);
    };

    return (
        <FormPageLayout
            title={product.name ? product.name : product.id}
            pageNavigation={<EditPageNavigation component={product}/>}
            tools={tools}
        >
            <Stack gap='lg'>
                <Profile
                    record={product}
                    onRecordUpdate={() => {
                        fetchRecord();
                    }}
                />
            </Stack>

            <FormDrawer
                record={product}
                handleSubmit={handleDrawerSubmit}
                opened={drawerOpened}
                onClose={() => setDrawerOpened(false)}
            />
        </FormPageLayout>
    );
};
